module.exports = __webpack_public_path__ + "static/media/money-bag.7f3fede5.png";